import { isS3Url } from "./isS3Url";

interface RequestConfig {
  url?: string;
  headers: Record<string, string | undefined>;
}

/**
 * Injects prosite-secret-token and Auth0 JWT on first-party requests.
 * Skips S3 presigned URLs, third-party origins, and internal auth endpoints.
 */
export const applyRequestHeaders = (req: RequestConfig): RequestConfig => {
  req.headers = req.headers ?? {};

  const isS3Request = isS3Url(req.url ?? "");
  if (isS3Request) {
    return req;
  }

  const serverUrl = process.env.REACT_APP_SERVER_URL;
  const isFirstParty = (() => {
    const url = (req.url ?? "").trim();
    const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(url);
    if (!hasScheme && !url.startsWith("//")) return true;
    if (serverUrl == null) return false;
    try {
      // Compare origins to prevent prefix-spoofing (e.g. evil.prophone.com)
      return new URL(url).origin === new URL(serverUrl).origin;
    } catch {
      // serverUrl is a relative path (e.g. "/api") — prefix check is safe here
      return url.startsWith(serverUrl);
    }
  })();

  if (process.env.REACT_APP_PROSITE_SECRET_TOKEN && isFirstParty) {
    req.headers["prosite-secret-token"] =
      process.env.REACT_APP_PROSITE_SECRET_TOKEN;
  }

  const isAuthEndpoint = /\/pi\/(auth|refresh|verify)\/internal/.test(
    req.url ?? ""
  );
  const hasAuthHeader = Object.keys(req.headers).some(
    (k) => k.toLowerCase() === "authorization"
  );
  const token = localStorage.getItem("access_token");
  if (token && isFirstParty && !hasAuthHeader && !isAuthEndpoint) {
    req.headers["Authorization"] = `Bearer ${token}`;
  }

  return req;
};
